const indexItems = [
  { id: 1, title: '动作冒险', count: '3,286部', desc: '热血格斗·极限追击·英雄传奇', icon: 'ri-sword-line', color: 'text-accent-500 bg-accent-100' },
  { id: 2, title: '悬疑推理', count: '1,952部', desc: '层层反转·烧脑解谜·真相追踪', icon: 'ri-search-eye-line', color: 'text-secondary-500 bg-secondary-100' },
  { id: 3, title: '科幻奇幻', count: '1,847部', desc: '未来世界·星际探索·想象无界', icon: 'ri-rocket-line', color: 'text-primary-500 bg-primary-100' },
  { id: 4, title: '喜剧幽默', count: '2,514部', desc: '爆笑不断·轻松解压·合家欢乐', icon: 'ri-emotion-laugh-line', color: 'text-accent-500 bg-accent-100' },
  { id: 5, title: '爱情文艺', count: '1,683部', desc: '浪漫邂逅·心动瞬间·感人至深', icon: 'ri-heart-line', color: 'text-secondary-500 bg-secondary-100' },
  { id: 6, title: '恐怖惊悚', count: '1,246部', desc: '毛骨悚然·胆量挑战·深夜禁忌', icon: 'ri-ghost-line', color: 'text-primary-500 bg-primary-100' },
  { id: 7, title: '纪录片', count: '985部', desc: '真实纪录·深度探索·人文关怀', icon: 'ri-camera-line', color: 'text-accent-500 bg-accent-100' },
  { id: 8, title: '动画动漫', count: '2,103部', desc: '二次元世界·经典IP·全龄共享', icon: 'ri-magic-line', color: 'text-secondary-500 bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            电影大全
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            按类型浏览海量高清电影资源，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-3.5 p-4 md:p-5 rounded-lg bg-background-200/70 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <span className={`w-11 h-11 flex items-center justify-center rounded-lg ${item.color} shrink-0 transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5 line-clamp-1">
                  {item.desc}
                </p>
                <p className="text-xs text-primary-500 font-medium mt-1.5">
                  {item.count}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}